<template>
    <div>
        <h1 class="subtitle">Unidades</h1>
        <hr />
        <div class="columns">
            <div class="column is-9">
                <button class="button is-success" @click="showBox = true">
                    <b-icon icon="plus" size="is-small"></b-icon> <span>Agregar</span>
                </button>
            </div>
            <div class="column is-3">
                <input type="text" class="input is-pulled-right" @keyup="searchData" placeholder="Buscar" v-model="search" />
            </div>
        </div>
        <b-table :data="data" :loading="loading" paginated bordered backend-pagination :total="total" :per-page="perPage" aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Pág." aria-current-label="Pág. actual" @page-change="onPageChange">
            <template slot-scope="props">
                <b-table-column field="simbolo" label="Unidad" header-class="is-info">
                    {{ props.row.simbolo }}
                </b-table-column>
                <b-table-column field="descripcion" label="Descripción" header-class="is-info">
                    {{ props.row.descripcion }}
                </b-table-column>
                <b-table-column label="" header-class="is-info">
                    <a href="#" @click.prevent="deleteRow(props.row)" title="Eliminar"><span class="icon has-text-danger">
                            <i class="mdi mdi-delete mdi-18px"></i> </span></a>
                </b-table-column>
            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>No se encontraron Unidades</p>
                    </div>
                </section>
            </template>
        </b-table>
        <b-modal :active.sync="showBox">
            <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Agregar Unidad</p>
                    </header>
                    <section class="modal-card-body">
                        <b-field label="Simbolo">
                            <b-input type="text" v-model="unidad.simbolo" required />
                        </b-field>
                        <b-field label="Descripción">
                            <b-input type="text" v-model="unidad.unidad" required />
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="showBox = false">
                            Close
                        </button>
                        <button class="button is-primary" @click.prevent="addUnidad()">
                            Agregar Unidad
                        </button>
                    </footer>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios"
export default {
    name: "UnidadList",
    data() {
        return {
            loading: false,
            data: [],
            perPage: 10,
            total: 0,
            page: 1,
            search: "",
            timer: null,
            unidad: {
                simbolo: "",
                unidad: ""
            },
            showBox: false
        }
    },
    methods: {
        deleteRow(row) {
            this.$buefy.dialog.confirm({
                message: "Esta seguro de eliminar la unidad",
                onConfirm: () => {
                    axios
                        .delete("/unidad/delete", { data: { id_unidad: row.id_unidad } })
                        .then(
                            () => {
                                this.$buefy.toast.open({
                                    message: `Se elimino la unidad ${row.descripcion}`,
                                    type: "is-success"
                                })
                                this.loadDataTable()
                            },
                            () => {
                                this.$buefy.toast.open({
                                    message: `Ocurrio un problema al eliminar la unidad`,
                                    type: "is-danger"
                                })
                            }
                        )
                }
            })
        },
        loadDataTable() {
            let _self = this
            _self.loading = true
            axios
                .post("/unidad/list", {
                    search: this.search,
                    length: this.perPage,
                    start: (this.page - 1) * this.perPage
                })
                .then(
                    response => {
                        _self.data = response.data.data
                        _self.total = response.data.total
                        _self.loading = false
                    },
                    () => {
                        _self.loading = false
                    }
                )
        },
        onPageChange(page) {
            this.page = page
            this.loadDataTable()
        },
        searchData() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            let _self = this
            this.timer = setTimeout(() => _self.loadDataTable(), 1000)
        },
        addUnidad() {
            let _self = this
            axios.post("/unidad/new", _self.unidad).then(
                response => {
                    this.$buefy.toast.open({
                        message: `Se agrego la unidad ${response.data.descripcion}`,
                        type: "is-success"
                    })
                    this.loadDataTable()
                    _self.showBox = false
                },
                err => {
                    this.$buefy.toast.open({
                        message: err.response.data.message,
                        type: "is-danger"
                    })
                    _self.showBox = false
                }
            )
        }
    },
    mounted() {
        this.loadDataTable()
    }
}
</script>

<style scoped></style>
